
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manage/list-pair",
      function () {
        return require("private-next-pages/manage/list-pair.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manage/list-pair"])
      });
    }
  